import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/invoice-actions';
import { InvoiceActions, OrderRemainingHoursReportActions, SeanceActions } from '../constants';
import { IInvoice, IInvoiceDoc } from 'src/types/invoice';

export interface InvoiceState {
    inProgress: boolean;
    inProgressCSV: boolean;
    authCode: string;
    error: string;
    totals: any;
    data: Paginated<IInvoice>;
    dataDocs: Paginated<IInvoiceDoc>;
    current: IInvoice | null;
    currentFiles: any | null;
    signers: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    totals: {},
    inProgressCSV: false,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    dataDocs: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    current: null,
    currentFiles: null,
    signers: null,
};

export function invoices(state: InvoiceState = initialState, action: Actions | any): InvoiceState {
    switch (action.type) {
        case requestType(InvoiceActions.PERSIST_INVOICE):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.PERSIST_INVOICE):
            if (state.data.list.length) {
                state.data.list.forEach((itInv, k) => {
                    if (`${itInv.id}` === `${action.payload.id}`) {
                        state.data.list[k] = action.payload;
                    }
                });
                return {
                    ...state,
                    current: action.payload,
                    inProgress: false,
                    data: { ...state.data, list: [...state.data.list] },
                };
            }
            return { ...state, current: action.payload, inProgress: false };
        case failureType(InvoiceActions.PERSIST_INVOICE):
            return { ...state, error: action.error, inProgress: false };

        case requestType(InvoiceActions.NOTIFY_SIGNER_ON_INVOICE):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.NOTIFY_SIGNER_ON_INVOICE):
            return { ...state, inProgress: false };
        case failureType(InvoiceActions.NOTIFY_SIGNER_ON_INVOICE):
            return { ...state, error: action.error, inProgress: false };

        case requestType(InvoiceActions.SEND_INVOICE_TO_DOCUSIGN):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.SEND_INVOICE_TO_DOCUSIGN):
            return { ...state, inProgress: false };
        case failureType(InvoiceActions.SEND_INVOICE_TO_DOCUSIGN):
            return { ...state, error: action.error, inProgress: false };

        case requestType(InvoiceActions.SEND_INVOICE_TO_PARENT):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.SEND_INVOICE_TO_PARENT):
            return { ...state, inProgress: false };
        case failureType(InvoiceActions.SEND_INVOICE_TO_PARENT):
            return { ...state, error: action.error, inProgress: false };

        case requestType(InvoiceActions.SAVE_INVOICE_REASON):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.SAVE_INVOICE_REASON):
            return { ...state, inProgress: false };
        case failureType(InvoiceActions.SAVE_INVOICE_REASON):
            return { ...state, error: action.error, inProgress: false };

        case requestType(InvoiceActions.SAVE_INVOICE_NOTE):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.SAVE_INVOICE_NOTE):
            return { ...state, inProgress: false };
        case failureType(InvoiceActions.SAVE_INVOICE_NOTE):
            return { ...state, error: action.error, inProgress: false };

        case requestType(InvoiceActions.SEND_STATEMENT_TO_PARENT):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.SEND_STATEMENT_TO_PARENT):
            return { ...state, inProgress: false };
        case failureType(InvoiceActions.SEND_STATEMENT_TO_PARENT):
            return { ...state, error: action.error, inProgress: false };

        case requestType(InvoiceActions.CREATE_INVOICE):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.CREATE_INVOICE):
            return { ...state, inProgress: false };
        case failureType(InvoiceActions.CREATE_INVOICE):
            return { ...state, error: action.error, inProgress: false };

        case requestType(InvoiceActions.SIGN_INVOICE_DOC):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.SIGN_INVOICE_DOC):
            if (!state.currentFiles) {
                return { ...state, inProgress: false };
            }
            const currentFiles = state.currentFiles.map((file: any) => {
                if (file.id === action.payload.id) {
                    return {
                        ...file,

                        ...action.payload,
                    };
                }
                return file;
            });

            return {
                ...state,
                current: state.current ? { ...state.current, status: 3 } : null,
                currentFiles,
                inProgress: false,
            };
        case failureType(InvoiceActions.SIGN_INVOICE_DOC):
            return { ...state, error: action.error, inProgress: false };

        case requestType(InvoiceActions.FETCH_INVOICES):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],

                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                            updatedAt: null,
                        },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(InvoiceActions.FETCH_INVOICES):
            return {
                ...state,
                data: {
                    ...action.payload,
                    list: Object.keys(state.totals).length
                        ? [state.totals, ...action.payload.list]
                        : action.payload.list,
                    inProgress: false,
                },
                inProgress: false,
            };
        case failureType(InvoiceActions.FETCH_INVOICES):
            return {
                ...state,
                data: { ...state.data, inProgress: false },
                error: action.error,
                inProgress: false,
            };


        case requestType(InvoiceActions.FETCH_INVOICES_SIMPLY):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],

                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                            updatedAt: null,
                        },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(InvoiceActions.FETCH_INVOICES_SIMPLY):
            return {
                ...state,
                data: {
                    ...action.payload,
                    list: Object.keys(state.totals).length
                        ? [state.totals, ...action.payload.list]
                        : action.payload.list,
                    inProgress: false,
                },
                inProgress: false,
            };
        case failureType(InvoiceActions.FETCH_INVOICES_SIMPLY):
            return {
                ...state,
                data: { ...state.data, inProgress: false },
                error: action.error,
                inProgress: false,
            };




        case successType(InvoiceActions.FETCH_INVOICES_TOTALS):
            if (action.total) {
                return {
                    ...state,
                    totals: action.payload,
                    data: {
                        ...state.data,
                        ...action.payload,
                        list: Object.keys(action.payload).length
                            ? [action.payload, ...state.data?.list]
                            : state.data?.list,
                        inProgress: false,
                    },
                    inProgress: false,
                };
            }
            return state;
        case failureType(InvoiceActions.FETCH_INVOICES_TOTALS):
            return { ...state, totals: {}, error: action.error, inProgress: false };
        case requestType(InvoiceActions.FETCH_INVOICES_TOTALS):
            return { ...state, inProgress: true, totals: {}, error: '' };

        case requestType(InvoiceActions.FETCH_INVOICE):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(InvoiceActions.FETCH_INVOICE):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(InvoiceActions.FETCH_INVOICE):
            return { ...state, inProgress: false, error: action.error };
        case requestType(InvoiceActions.FETCH_INVOICES_CSV):
            return {
                ...state,
                inProgressCSV: true,
            };
        case successType(InvoiceActions.FETCH_INVOICES_CSV):
            return {
                ...state,
                inProgressCSV: false,
            };
        case failureType(InvoiceActions.FETCH_INVOICES_CSV):
            return {
                ...state,
                inProgressCSV: false,
            };
        case requestType(InvoiceActions.DELETE_INVOICE):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.DELETE_INVOICE):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IInvoice) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(InvoiceActions.DELETE_INVOICE):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        case requestType(InvoiceActions.FETCH_FILES_INVOICE):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.FETCH_FILES_INVOICE):
            return { ...state, inProgress: false, currentFiles: action.payload };
        case failureType(InvoiceActions.FETCH_FILES_INVOICE):
            return { ...state, inProgress: false, error: action.error };

        case requestType(InvoiceActions.FETCH_SIGNERS_INVOICE):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.FETCH_SIGNERS_INVOICE):
            return { ...state, inProgress: false, signers: action.payload };
        case failureType(InvoiceActions.FETCH_SIGNERS_INVOICE):
            return { ...state, inProgress: false, error: action.error };

        case requestType(InvoiceActions.DELETE_FILE_INVOICE):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.DELETE_FILE_INVOICE):
            const { sagaPayload } = action;
            const curNewFiles = (state.currentFiles ?? []).filter((file: any) => file.id !== sagaPayload.id);

            return {
                ...state,
                inProgress: false,
                currentFiles: curNewFiles,
            };
        case failureType(InvoiceActions.DELETE_FILE_INVOICE):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case requestType(InvoiceActions.CREATE_FILES_INVOICE):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.CREATE_FILES_INVOICE):
            const curFiles = [...(state.currentFiles ?? [])];
            curFiles.push(action.payload);

            return {
                ...state,
                inProgress: false,
                currentFiles: curFiles,
            };

        case failureType(InvoiceActions.CREATE_FILES_INVOICE):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case requestType(InvoiceActions.APPROVE_INVOICE_DOCS):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.APPROVE_INVOICE_DOCS):
            return {
                ...state,
                inProgress: false,
            };
        case failureType(InvoiceActions.APPROVE_INVOICE_DOCS):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case requestType(InvoiceActions.DECLINE_INVOICE_DOCS):
            return { ...state, error: '', inProgress: true };
        case successType(InvoiceActions.DECLINE_INVOICE_DOCS):
            return {
                ...state,
                inProgress: false,
            };
        case failureType(InvoiceActions.DECLINE_INVOICE_DOCS):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case requestType(InvoiceActions.FETCH_INVOICE_DOCS):
            return {
                ...state,
                dataDocs: {
                    ...state.dataDocs,
                    list: [],
                    meta: state.dataDocs?.meta?.updatedAt
                        ? state.dataDocs?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(InvoiceActions.FETCH_INVOICE_DOCS):
            return { ...state, dataDocs: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(InvoiceActions.FETCH_INVOICE_DOCS):
            return {
                ...state,
                dataDocs: { ...state.dataDocs, inProgress: false },
                error: action.error,
                inProgress: false,
            };

        default:
            return state;
    }
}
